import React, {useState } from 'react'
import { _ } from 'src/utils'
import { Tabs, Tab, Button } from '..';
import { useTranslation } from 'src/contexts/TranslationContext';

export function TabSelector(props) {
    const [value, setValue] = useState(0);
    const {gettext} = useTranslation()

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className="page-selector-container">
            <div className="page-selector">
                <Tabs value={value} onChange={handleChange} centered variant="fullWidth">
                    {props.links?.map((link, i) => 
                        <Tab 
                            key={i} 
                            label={gettext(props.titles[i])} 
                            onClick={() => props.handleChange(link)}>
                        </Tab>
                    )}
                </Tabs>
            </div>

            {/*<Button 
                disableElevation 
                variant="contained" 
                sx={{
                    borderRadius: '100px', 
                    width: '97px', 
                    height: '39px', 
                    background: '#006E58', 
                    color: '#FFFFFF', 
                    marginLeft: '32px'}}>
                {_("Export")}
                </Button>*/}
        </div>
    )
}

 